"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedFindMyCombosResponseListResults = instanceOfPaginatedFindMyCombosResponseListResults;
exports.PaginatedFindMyCombosResponseListResultsFromJSON = PaginatedFindMyCombosResponseListResultsFromJSON;
exports.PaginatedFindMyCombosResponseListResultsFromJSONTyped = PaginatedFindMyCombosResponseListResultsFromJSONTyped;
exports.PaginatedFindMyCombosResponseListResultsToJSON = PaginatedFindMyCombosResponseListResultsToJSON;
exports.PaginatedFindMyCombosResponseListResultsToJSONTyped = PaginatedFindMyCombosResponseListResultsToJSONTyped;
const variant_1 = require("./variant");
/**
 * Check if a given object implements the PaginatedFindMyCombosResponseListResults interface.
 */
function instanceOfPaginatedFindMyCombosResponseListResults(value) {
    if (!('identity' in value) || value['identity'] === undefined)
        return false;
    if (!('included' in value) || value['included'] === undefined)
        return false;
    if (!('includedByChangingCommanders' in value) || value['includedByChangingCommanders'] === undefined)
        return false;
    if (!('almostIncluded' in value) || value['almostIncluded'] === undefined)
        return false;
    if (!('almostIncludedByAddingColors' in value) || value['almostIncludedByAddingColors'] === undefined)
        return false;
    if (!('almostIncludedByChangingCommanders' in value) || value['almostIncludedByChangingCommanders'] === undefined)
        return false;
    if (!('almostIncludedByAddingColorsAndChangingCommanders' in value) || value['almostIncludedByAddingColorsAndChangingCommanders'] === undefined)
        return false;
    return true;
}
function PaginatedFindMyCombosResponseListResultsFromJSON(json) {
    return PaginatedFindMyCombosResponseListResultsFromJSONTyped(json, false);
}
function PaginatedFindMyCombosResponseListResultsFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'identity': json['identity'],
        'included': (json['included'].map(variant_1.VariantFromJSON)),
        'includedByChangingCommanders': (json['includedByChangingCommanders'].map(variant_1.VariantFromJSON)),
        'almostIncluded': (json['almostIncluded'].map(variant_1.VariantFromJSON)),
        'almostIncludedByAddingColors': (json['almostIncludedByAddingColors'].map(variant_1.VariantFromJSON)),
        'almostIncludedByChangingCommanders': (json['almostIncludedByChangingCommanders'].map(variant_1.VariantFromJSON)),
        'almostIncludedByAddingColorsAndChangingCommanders': (json['almostIncludedByAddingColorsAndChangingCommanders'].map(variant_1.VariantFromJSON)),
    };
}
function PaginatedFindMyCombosResponseListResultsToJSON(json) {
    return PaginatedFindMyCombosResponseListResultsToJSONTyped(json, false);
}
function PaginatedFindMyCombosResponseListResultsToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'identity': value['identity'],
        'included': (value['included'].map(variant_1.VariantToJSON)),
        'includedByChangingCommanders': (value['includedByChangingCommanders'].map(variant_1.VariantToJSON)),
        'almostIncluded': (value['almostIncluded'].map(variant_1.VariantToJSON)),
        'almostIncludedByAddingColors': (value['almostIncludedByAddingColors'].map(variant_1.VariantToJSON)),
        'almostIncludedByChangingCommanders': (value['almostIncludedByChangingCommanders'].map(variant_1.VariantToJSON)),
        'almostIncludedByAddingColorsAndChangingCommanders': (value['almostIncludedByAddingColorsAndChangingCommanders'].map(variant_1.VariantToJSON)),
    };
}
//# sourceMappingURL=paginatedFindMyCombosResponseListResults.js.map